import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateTwitter, connectTwitter } from "../../../../store/slices/authSlice";
import TwitterPopup from "../../../../components/TwitterPopup/TwitterPopup";

const Twitter = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleConnect = () => {
    setIsPopupOpen(true);
  };

  const handleDisconnect = async () => {
    try {
      await dispatch(updateTwitter()).unwrap();
    } catch (error) {
      console.error("Error disconnecting Twitter:", error);
    }
  };

  const handleSuccess = (twitterData) => {
    dispatch(connectTwitter(twitterData));
    setIsPopupOpen(false);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const isConnected = user?.attributes?.twitter?.displayName;

  return (
    <div className="ps-3">
      <div className="form_div row w-100">
        <div className="InnerHeading">
          <h4>X/Twitter</h4>
        </div>
        <div className="form-card col-9 d-flex justify-content-around align-items-center">
          <div className="form-elements w-75">
            {isConnected ? `@${user.attributes.twitter.displayName}` : "Please attach your twitter account to make your feed available in the RadioFX Application"}
          </div>
          <div className="button-div">
            <button 
              type="button"
              onClick={isConnected ? handleDisconnect : handleConnect}
              className="btn btn-primary"
            >
              <span>
                {isConnected ? "Disconnect" : "Connect"}
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Twitter Popup */}
      <TwitterPopup
        isOpen={isPopupOpen}
        onClose={handleClose}
        onSuccess={handleSuccess}
        jwt={localStorage.getItem('authToken') || sessionStorage.getItem('authToken')}
      />
    </div>
  );
};

export default Twitter;

